import { ComponentHandler } from 'src/app/services/component-services/component-handler';
import { GtinCheckService } from './../../../../services/component-services/gtin-check-service';
import { AuthService } from './../../../../services/auth-service';
import { ColorThemeService } from './../../../../navigation/services/color-theme-service';
import { PackagingComponentTypesEnum } from './../../../../model/packaging-component-types-enum';
import { DictionaryHandler } from './../../../../model/dictionary';
import { ComponentTypeService } from './../../../../navigation/services/component-type-service';
import { ComponentApiService } from '../../../../data-transfer/services/component-api-service';
import { ComponentCreateUpdateParentComponent } from './../common/component-create-update-parent/component-create-update-parent.component';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, HostListener } from '@angular/core';
import { ComponentNavigationService } from 'src/app/navigation/services/navigation-services/component-navigation-service';
import { ComponentCanDeactivate } from 'src/app/services/unsaved-changes-guard';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { COLOR_THEME_DARK } from 'src/app/navigation/services/color-theme-service';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { PackagingAidDto } from 'src/app/data-transfer/entities/component-entities/packaging-aid-dto';

@Component({
  selector: 'app-create-update-packaging-aid',
  templateUrl: './create-update-packaging-aid.component.html',
  styleUrls: ['./create-update-packaging-aid.component.scss']
})
export class CreateUpdatePackagingAidComponent extends ComponentCreateUpdateParentComponent
  implements OnInit, ComponentCanDeactivate {

  packagingAid!: PackagingAidDto;

  constructor(
    protected componentHandler: ComponentHandler,
    protected dialog: MatDialog,
    protected spinner: NgxSpinnerService,
    protected componentApiService: ComponentApiService,
    protected navigationService: ComponentNavigationService,
    protected componentTypeService: ComponentTypeService,
    protected dictionaryHandler: DictionaryHandler,
    protected fileApiService: FileApiService,
    protected authService: AuthService,
    protected gtinCheckService: GtinCheckService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private colorThemeService: ColorThemeService
  ) {
    super(componentHandler, dialog, spinner, componentApiService, navigationService,
      componentTypeService, dictionaryHandler, fileApiService, authService, gtinCheckService);
  }

  ngOnInit(): void {
    this.callerId = PackagingComponentTypesEnum.PackagingAid;
    this.componentType = this.componentTypeService.getComponentTypeDtoByName('packaging aid');
    this.componentSubtypes = this.componentHandler.getComponentSubtypesSelection(this.callerId);

    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.component) {
        this.packagingAid = data.component;
        this.historyVersions = [{
          id: data.component.id,
          versionNumber: data.component.version,
          versionName: data.component.versionName,
          creationTimestamp: data.component.creationTimestamp,
          isCurrentVersion: data.component.isCurrentVersion,
          packagingComponentCategoryId: this.callerId
        }];
        this.currentDirectoryId = data.component.directoryId;
        if (this.form) {
          window.location.reload();
          super.initComponent(this.packagingAid, this.route);
        }
      } else {
        this.packagingAid = new PackagingAidDto();
        this.packagingAid.images = [];
        this.packagingAid.certificates = [];
        this.packagingAid.documents = [];
      }
      if (data.permissions) {
        this.permissions = data.permissions;
      }
      if (data.changedMaterialIds && data.changedMaterialIds.length > 0) {
        super.setChangedMultiMaterials(this.packagingAid.multiMaterial.subMultiMaterials, data.changedMaterialIds);
      }
    });

    super.initComponent(this.packagingAid, this.route);
    const packAidComponent = this.componentHandler.components[this.callerId];
    this.form = packAidComponent.createBaseForm(this.packagingAid, this.formBuilder, this.componentSubtypes, this.isTracked);
    this.form = this.formBuilder.group({
      ...this.form.controls,
      distributionCountries: [this.packagingAid.distributionCountries],
      printingCoverage: [this.packagingAid.printingCoverage != null ? this.packagingAid.printingCoverage * 100 : null,
      [Validators.min(0), Validators.max(100)]]
    });
    this.form.controls.totalWeight.disable();
    super.initGtinCheck();

    this.setUpLockAndHeartbeat(this.packagingAid);
    this.disableFormIfRequired();

    this.themeSubscription = this.colorThemeService.colorThemeSubject.subscribe((nextValue) => {
      this.isDarkTheme = nextValue === COLOR_THEME_DARK;
      this.imageSource = this.componentTypeService.getComponentTypeImage(this.callerId, this.isDarkTheme);
    });
  }

  async onComponentSubmit(materialEdited: boolean) {
    this.materialEdited = materialEdited;
    this.form.markAllAsTouched();
    const packAidComponent = this.componentHandler.components[this.callerId];
    this.packagingAid = packAidComponent.getSingleComponentFromForm(this.form.getRawValue(), false, this.packagingAid) as PackagingAidDto;
    // this.packagingAid.packagingComponentSubtypeId = this.form.controls.packagingComponentSubtypeId.value;

    super.onSubmit(this.packagingAid);
  }

  changePackAidVersionName(event: { historyVersion: VersionDto, newName: string }) {
    super.changeVersionName(event.historyVersion, event.newName, this.packagingAid);
  }

  async releaseComponent() {
    super.releaseComponent(this.packagingAid);
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.form.pristine && !this.filesEdited) || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }

  handleMaterialChange(materialChange: { accepted: boolean, materialId: number }) {
    if (this.packagingAid.id == null) { return; }
    super.handleMaterialChangeParent(this.packagingAid.id, materialChange.materialId, materialChange.accepted);
  }
}
